/********************************************销售结算**************************************** */
let salessettlement = resolve => require(['@/components/settlement/settlement/index.vue'], resolve)
/**************详情***************/
let salessettledetail = resolve => require(['@/components/settlement/settlement/salessettledetail.vue'], resolve)
// 打印页面
let settleStatement =resolve => require(['@/components/settlement/settlement/settle_statements.vue'], resolve)



export default [{ //销售结算
        path: '/homeMain/settlement/salessettlement',
        component: salessettlement,
        meta: {
            keepAlive: true
        }
    },
    { //销售结算详情
        path: '/homeMain/settlement/salessettledetail',
        component: salessettledetail
    },
    { //打印单
        path: '/homeMain/settlement/settle_statements',
        component: settleStatement
    }
]


// WEBPACK FOOTER //
// ./src/router/settlement.js